import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;

export const checkBinding = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-binding`
  });

export const sendSmsValidate = (mobileInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/send-sms-validate`,
    body: mobileInfo
  });

export const validateSms = (validateInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/validate-sms`,
    body: validateInfo
  });

export const doBinding = (userInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/do-binding`,
    body: userInfo
  });

  export const getSaList = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/get-binding-sa-url`
  });
